import CreatorLink from "./CreatorLink";
import { creatorsFromSource } from "../helpers.mjs";

// exclude allows you to leave types out of the list, commasOnly: separate every name with a comma, instead of using "and" before the last one
const Creators = ({source, exclude = [], commasOnly = false}) => {
    const allCreators = creatorsFromSource(source);
    const filteredCreators = allCreators.filter(c => !exclude.includes(c.type));
    const creators = filteredCreators.length > 0 ? filteredCreators : allCreators;

    return <>
        {creators.map((c, i) => {
            return <span key={"k"+i}>
                <CreatorLink key={i} creator={c.creator} type={c.type} typeD={c.typeD} />
                {(!commasOnly && i === (creators.length-2) && <span key={"sp"+i}>&nbsp;and&nbsp;</span>) || (i !== (creators.length-1) && creators.length>1 && <span key={"s"+i}>,&nbsp;</span>)}
            </span>
        })}
    </>
}

export default Creators;
